import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

type P = {
  text?: string;
};

const Separator: FC<P> = ({ text }) => {
  const { t } = useTranslation();

  return <div className="form-separator">{text ? <div className="form-separator__text">{t(text)}</div> : null}</div>;
};

export default Separator;
